import React, { useEffect } from "react";

import { useLocation } from "react-router-dom";

// It scrolls to the top of the page whenever the route changes.
const ScrollToTop = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return React.Children.only(children);
};

export default ScrollToTop;
